/* eslint-disable no-unused-vars */
/**
 * Creates an instance of FormSubmission.
 * @typedef {Object} FormSubmissionType
 * @property {number} id - The unique identifier for the form submission.
 * @property {number} formId - The ID of the associated form.
 * @property {number} formVersionNo - The version number of the form.
 * @property {Date} createdDateUTC - The UTC timestamp when the submission was created.
 * @property {?Date} lastModifiedDateUTC - The UTC timestamp when the submission was last modified (nullable).
 * @property {?Date} completedDateUTC - The UTC timestamp when the submission was completed (nullable).
 * @property {FormSubmissionState} state - The state of the form submission (e.g., "Draft", "Submitted", etc.).
 * @property {Object} values - Key/Value responses to the form questions.
 */

import { FormSubmissionState } from '@/constants/form/FormSubmissionState'

/**
 * Represents a form submission response.
 * @class
 */
export default class FormSubmission {
  /**
   * Create a new FormSubmission.
   * @param {FormSubmissionType} params
   */
  constructor(params) {
    this.id = params.id
    this.formId = params.formId
    this.formVersionNo = params.formVersionNo
    this.createdDateUTC = params.createdDateUTC
    this.lastModifiedDateUTC = params.lastModifiedDateUTC
    this.completedDateUTC = params.completedDateUTC
    this.state = params.state
    this.values = params.values
  }
}
